<template>
  <v-dialog v-model="dialog" persistent max-width="1300">
    <v-card>
      <v-card-title class="d-flax px-12 pt-12">
        <v-row>
          <v-col cols="12" align-self="center" class="px-0 d-flex">
            <span v-if="hospital_detail.type !== 'factory'" class="text-333333 font-20 w-700" style="align-self: center;">เพิ่มข้อมูลองค์กร</span>
            <span v-else class="text-333333 font-20 w-700" style="align-self: center;">เพิ่มข้อมูลสถานประกอบการ</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePage()" small color="#00A99D">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="tab" color="#00A99D" grow>
          <v-tab v-for="(item, index) in items" :key="index">{{ item }}</v-tab>
        
          <v-tab-item v-if="items.some(e => { return e == 'รายละเอียดองค์กร' }) == true  || items.some(e => { return e == 'รายละเอียดสถานประกอบการ' }) == true">
            <v-form ref="new_organize" class="px-3">
              <v-divider></v-divider>
              <v-card flat style="overflow-y: auto; overflow-x: hidden; min-height: 455px;" color="#ceefed">
                <v-card-text style="line-height: 1.8;">
                  <v-row justify="center" style="background-color: #ceefed;">
                  <v-col cols="10" xl="3" lg="3" md="5" sm="5" class="mb-1">
                    <v-sheet v-if="checkImg" color="#EFF6FC" class="mx-auto pt-12 mt-5" height="300" @click="onButtonClick" style="cursor: pointer;">
                      <v-row justify="center" class="pt-12">
                        <img :src="require('@/assets/icon/picture.png')" style="width: 70px;" />
                      </v-row>
                      <v-row justify="center">
                        <v-icon size="20" color="#1CA7B4">mdi-plus</v-icon><span class="set-font-add-image w-700">เพิ่มรูปภาพ</span>
                      </v-row>
                    </v-sheet>
                    <v-img v-else :src="hospital_detail.organize_logo" class="mt-5 mr-0" contain height="300" style="margin-left: 310px;"
                      @click="onButtonClick"></v-img>
                    <input ref="uploader" class="d-none" type="file" accept="image/*" @change="onFileChanged" />
                  </v-col>
                </v-row>
                  <v-row class="pl-3">
                    <v-col cols="12" sm="auto" md="auto" class="pl-0" style="display: contents;">
                      <v-radio-group
                        v-model="hospital_detail.type"
                        hide-details="auto"
                        row
                        @change="showType(hospital_detail.type, hospital_detail.service)"
                      >
                        <v-radio
                          value="organization"
                          color="#00A99D"
                        >
                          <template slot="label">
                            <span class="font-16 w-500 text-333333">ข้อมูลองค์กร</span>
                          </template>
                        </v-radio>

                        <v-radio
                          value="factory"
                          color="#00A99D"
                        >
                          <template slot="label">
                            <span class="font-16 w-500 text-333333">ข้อมูลสถานประกอบการ</span>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col v-if="hospital_detail.type == 'factory'" cols="12" sm="4" md="4" align-self="center">
                      <v-autocomplete
                        :items="itemTable"
                        item-value="biz_id"
                        item-text="first_name_th"
                        :menu-props="{ bottom: true, offsetY: true }"
                        solo
                        dense
                        hide-details="auto"
                        placeholder="กรุณาเลือกองค์กร"
                        v-model="hospital_detail.organizatio"
                        item-color="teal darken-2"
                        color="#00A99D"
                        :rules="rule_organization"
                      >
                        <template slot="no-data">
                          <span class="pl-2">ไม่มีข้อมูลองค์กร</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-if="hospital_detail.type !== 'factory'">
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" xl="3" lg="3" md="4" sm="4" v-for="(item, index) in service" :key="index" class="py-0" align-self="center">
                          <v-checkbox
                            v-model="hospital_detail.service"
                            :value="item"
                            color="#00A99D"
                            hide-details="auto"
                            @change="showType(hospital_detail.type, hospital_detail.service)"
                          >
                            <template slot="label">
                              <v-avatar v-if="item.service == 'telemed'" left size="30">
                                <v-img :src="require('@/assets/icon/telemed.svg')"></v-img>
                              </v-avatar>
                              <v-avatar v-if="item.service == 'telepharma'" left size="30">
                                <v-img :src="require('@/assets/icon/Logo_Navbar_Health_Rider_2.png')"></v-img>
                              </v-avatar>
                              <span v-if="item.service == 'telemed'" class="pl-2 font-16 text-333333 w-400">{{ item.service[0].toUpperCase() }}{{ item.service.slice(1) }}</span>
                              <span v-else class="pl-2 font-16 text-333333 w-400">Health Rider</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <span class="font-16 w-500 text-333333">Business ID</span>
                      <span class="text-E26269 font-16 w-500"> *</span>
                      <v-text-field
                        v-model="hospital_detail.biz_id"
                        placeholder="กรอก Business ID"
                        solo
                        dense
                        hide-details="auto"
                        require
                        :rules="rule_business"
                        hint="สามารถกด Enter เพื่อค้นหาข้อมูลใน one platform ได้"
                        @keypress.enter="getHospitalBiz(hospital_detail.biz_id)"
                        :loading="loading1"
                        color="#1CA7B4"
                      >
                      <template slot="append">
                        <v-tooltip top v-if="getBiz === false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="#F44336">mdi-close-thick</v-icon>
                            </v-btn>
                          </template>
                          <span>ไม่พบข้อมูลใน one platform</span>
                        </v-tooltip>
                        <v-tooltip top v-else-if="getBiz === true">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="#4CAF50">mdi-check-bold</v-icon>
                            </v-btn>
                          </template>
                          <span>พบข้อมูลใน one platform</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
                    <v-col v-if="hospital_detail.type !== 'factory'" cols="12" sm="6" md="6">
                      <span class="font-16 w-500 text-333333">Hospital Code</span>
                      <v-text-field
                        v-model="hospital_detail.hospital_code"
                        placeholder="กรอก Hospital Code"
                        solo
                        dense
                        hide-details="auto"
                        :loading="loading2"
                        hint="สามารถกด Enter เพื่อค้นหาข้อมูลใน one platform ได้"
                        @keypress.enter="getHospitalHosCode(hospital_detail.hospital_code)"
                        color="#1CA7B4"
                      >
                      <template slot="append">
                        <v-tooltip top v-if="getBizHosCode === false">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="#F44336">mdi-close-thick</v-icon>
                            </v-btn>
                          </template>
                          <span>ไม่พบข้อมูลใน one platform</span>
                        </v-tooltip>
                        <v-tooltip top v-else-if="getBizHosCode === true">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon color="#4CAF50">mdi-check-bold</v-icon>
                            </v-btn>
                          </template>
                          <span>พบข้อมูลใน one platform</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    </v-col>
                    <v-col v-else cols="12" sm="6" md="6"></v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span v-if="hospital_detail.type !== 'factory'" class="font-16 w-500 text-333333">ชื่อองค์กร (ภาษาไทย)</span>
                      <span v-else class="font-16 w-500 text-333333">ชื่อสถานประกอบการ (ภาษาไทย)</span>
                      <span class="text-E26269 font-16 w-500"> *</span>
                      <v-text-field
                        v-model="hospital_detail.first_name_th"
                        :placeholder="hospital_detail.type !== 'factory' ? 'กรอกชื่อองค์กร (ภาษาไทย)' : 'กรอกชื่อสถานประกอบการ (ภาษาไทย)'"
                        solo
                        dense
                        hide-details="auto"
                        require
                        :rules="rule_name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span v-if="hospital_detail.type !== 'factory'" class="font-16 w-500 text-333333">ชื่อองค์กร (ภาษาอังกฤษ)</span>
                      <span v-else class="font-16 w-500 text-333333">ชื่อสถานประกอบการ (ภาษาอังกฤษ)</span>
                      <v-text-field
                        v-model="hospital_detail.first_name_eng"
                        :placeholder="hospital_detail.type !== 'factory' ? 'กรอกชื่อองค์กร (ภาษาอังกฤษ)' : 'กรอกชื่อสถานประกอบการ (ภาษาอังกฤษ)'"
                        solo
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-row class="pt-3">
                            <v-col cols="12" class="pb-0">
                              <span class="font-16 w-500 text-333333">บ้านเลขที่</span>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-text-field
                                solo
                                dense
                                hide-details="auto"
                                placeholder="กรอกบ้านเลขที่"
                                v-model="hospital_detail.organize_location_object.house_no"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-row class="pt-3">
                            <v-col cols="12" class="pb-0">
                              <span class="font-16 w-500 text-333333">หมู่ที่</span>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-text-field
                                solo
                                dense
                                hide-details="auto"
                                placeholder="กรอกหมู่ที่"
                                v-model="hospital_detail.organize_location_object.moo"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-row class="pt-3">
                            <v-col cols="12" class="pb-0">
                              <span class="font-16 w-500 text-333333">ถนน/ซอย</span>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-text-field
                                solo
                                dense
                                hide-details="auto"
                                placeholder="กรอกถนน/ซอย"
                                v-model="hospital_detail.organize_location_object.road"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-row class="pt-3">
                            <v-col cols="12" class="pb-0">
                              <span class="font-16 w-500 text-333333">จังหวัด</span>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-autocomplete
                                :items="set_province"
                                item-value="province"
                                item-text="province"
                                @input="getAmphoe('template')"
                                :menu-props="{ bottom: true, offsetY: true }"
                                solo
                                dense
                                hide-details="auto"
                                placeholder="กรุณาเลือกจังหวัด"
                                v-model="hospital_detail.organize_location_object.province"
                                item-color="teal darken-2"
                                color="#00A99D"
                              >
                                <template slot="no-data">
                                  <span class="pl-2">ไม่มีข้อมูลจังหวัด</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-row class="pt-3">
                            <v-col cols="12" class="pb-0">
                              <span class="font-16 w-500 text-333333">อำเภอ/เขต</span>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-autocomplete
                                :items="set_amphoe"
                                item-value="amphoe"
                                item-text="amphoe"
                                @input="getTambon"
                                :menu-props="{ bottom: true, offsetY: true }"
                                solo
                                dense
                                hide-details="auto"
                                placeholder="กรุณาเลือกอำเภอ/เขต"
                                v-model="hospital_detail.organize_location_object.amphur"
                                item-color="teal darken-2"
                                color="#00A99D"
                              >
                                <template slot="no-data">
                                  <span class="pl-2">กรุณาเลือกจังหวัด</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <v-row class="pt-3">
                            <v-col cols="12" class="pb-0">
                              <span class="font-16 w-500 text-333333">ตำบล/แขวง</span>
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-autocomplete
                                :items="set_tambon"
                                item-value="tambon"
                                item-text="tambon"
                                @change="getPostal($event), showAddress()"
                                :menu-props="{ bottom: true, offsetY: true }"
                                solo
                                dense
                                hide-details="auto"
                                placeholder="กรุณาเลือกตำบล/แขวง"
                                v-model="hospital_detail.organize_location_object.tambon"
                                item-color="teal darken-2"
                                color="#00A99D"
                              >
                                <template slot="no-data">
                                  <span class="pl-2">กรุณาเลือกอำเภอ</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-row class="pt-3">
                            <v-col cols="12" class="pb-0">
                              <span class="font-16 w-500 text-333333"
                                >รหัสไปรษณีย์</span
                              >
                            </v-col>
                            <v-col cols="12" class="pt-0">
                              <v-text-field
                                solo
                                dense
                                hide-details="auto"
                                placeholder="กรอกรหัสไปรษณีย์"
                                @input="showAddress()"
                                v-model="hospital_detail.organize_location_object.postal_code"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span class="font-16 w-500 text-333333">ที่อยู่</span>
                      <v-textarea
                        class="text-333333"
                        v-model="clinic_location"
                        solo
                        dense
                        hide-details="auto"
                        rows="4"
                        disabled
                        style="background-color: #FAFAFA;"
                        color="#00A99D"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span class="font-16 w-500 text-333333">รายละเอียด</span>
                      <v-textarea
                        v-model="hospital_detail.organize_detail"
                        :placeholder="hospital_detail.type !== 'factory'? 'กรอกรายละเอียดองค์กร' : 'กรอกรายละเอียดสถานประกอบการ'"
                        solo
                        dense
                        hide-details="auto"
                        rows="4"
                        color="#00A99D"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <span class="font-16 w-500 text-333333">เบอร์โทร</span>
                      <v-text-field
                        v-model="hospital_detail.organize_phone"
                        placeholder="กรอกเบอร์โทร"
                        solo
                        dense
                        hide-details="auto"
                        maxlength="11"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <span class="font-16 w-500 text-333333">Tax id</span>
                      <v-text-field
                        v-model="hospital_detail.taxid"
                        placeholder="กรอก tax id"
                        solo
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                    
                    <!-- <v-col cols="12" sm="6" md="6">
                      <span class="font-16 w-500 text-333333">ค่าใช้บริการ</span>
                      <v-text-field
                        v-model="hospital_detail.organize_fee"
                        placeholder="ค่าใช้บริการ"
                        solo
                        dense
                        hide-details="auto"
                      ></v-text-field>
                    </v-col> -->
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" sm="4" md="4" align-self="end">
                          <v-btn depressed color="#F7F8FA" @click="checkGPS()" style="width: 100%">
                            <v-icon size="20" class="pr-1" color="#00A99D">mdi-crosshairs-gps</v-icon><span class="text-7E8386 w-400 font-14">คลิกเพื่อหาที่อยู่ปัจจุบันของคุณ</span>
                          </v-btn>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <span class="font-16 w-500 text-333333">ละติจูด</span>
                          <v-text-field
                            v-model="hospital_detail.latitude"
                            placeholder="ละติจูด"
                            solo
                            dense
                            @input="getGPS()"
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4">
                          <span class="font-16 w-500 text-333333">ลองติจูด</span>
                          <v-text-field
                            v-model="hospital_detail.longitude"
                            placeholder="ลองติจูด"
                            solo
                            dense
                            @input="getGPS()"
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <!-- <GmapAutocomplete
                        @place_changed="setPlace"
                        class="pl-2 gmap-auto"
                        :value="search"
                        :options="{
                          fields: [
                            'geometry',
                            'formatted_address',
                            'address_components',
                          ],
                        }"
                      /> -->
                      <v-text-field
                        solo
                        dense
                        placeholder="ค้นหาตำแหน่งที่อยู่"
                        v-model="location_address"
                        hide-details="auto"
                        @keypress.enter="getLocation(location_address)"
                        color="#00A99D"
                        hint="กรอกคำค้นหา กดปุ่มค้นหา เพื่อค้นหาที่อยู่ของท่าน"
                      >
                        <template slot="append">
                          <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs" v-on="on"
                                icon
                                color="#00A99D"
                                @click="getLocation(location_address)"
                              >
                                <v-icon medium dark>mdi-magnify</v-icon>
                              </v-btn>
                            </template>
                            <span>ค้นหา</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <GmapMap
                        :center="{ lat: latitude, lng: longitude }"
                        :zoom="15"
                        class="map"
                        :options="{
                          zoomControl: true,
                          mapTypeControl: false,
                          scaleControl: false,
                          streetViewControl: false,
                          rotateControl: true,
                          fullscreenControl: true,
                          disableDefaultUi: true,
                        }"
                      >
                        <GmapMarker
                          @click="changeLocation"
                          @dragend="changeLocation"
                          :draggable="true"
                          :position="{
                            lat: lat,
                            lng: lng,
                          }"
                        />
                      </GmapMap>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-form>
          </v-tab-item>
          <v-tab-item v-if="items.some(e => { return e == 'Health Rider' }) == true">
            <v-form ref="new_organize_pharma" class="px-3">
              <v-divider></v-divider>
              <v-card flat style="overflow-y: auto; overflow-x: hidden; min-height: 455px;" color="#ceefed">
                <v-card-text style="line-height: 1.8;">
                  <div class="px-0 pb-3" fluid style="border-radius: 12px;">
                    <v-row class="py-3 px-5 mt-0">
                      <v-col class="py-0" cols="12">
                        <span class="text-313B41 w-600 font-16">แบบตอบรับ Conference</span>
                      </v-col>
                    </v-row>
                    <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="mx-5">
                      <v-row class="px-5 mt-0 pb-3">
                        <v-col cols="12" class="pt-0 pr-1">
                          <v-radio-group v-model="hospital_detail.template_conference" row hide-details="auto">
                            <v-row>
                              <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                                <v-radio :value="false" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">ไม่เปิดให้ใช้บริการ</span>
                                  </template>
                                </v-radio>
                              </v-col>
                              <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                                <v-radio :value="true" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">เปิดให้ใช้บริการ</span>
                                  </template>
                                </v-radio>
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row class="py-3 px-5 mt-0">
                      <v-col class="py-0" cols="12">
                        <span class="text-313B41 w-600 font-16">สถานะการให้บริการ API</span>
                      </v-col>
                    </v-row>
                    <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="mx-5">
                      <v-row class="px-5 mt-0 pb-3">
                        <v-col cols="12" class="pt-0 pr-1">
                          <v-radio-group v-model="hospital_detail.pharma_setup.service_api" row hide-details="auto">
                            <v-row>
                              <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                                <v-radio :value="false" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">ไม่เปิดให้ใช้บริการ</span>
                                  </template>
                                </v-radio>
                              </v-col>
                              <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                                <v-radio :value="true" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">เปิดให้ใช้บริการ</span>
                                  </template>
                                </v-radio>
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row class="py-3 px-5 mt-0">
                      <v-col class="py-0" cols="12">
                        <span class="text-313B41 w-600 font-16">สิทธิการรักษา</span>
                      </v-col>
                    </v-row>
                    <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="mx-5">
                      <v-row class="px-5 mt-0 pb-3">
                        <v-col cols="5" sm="5" md="5" lg="5" class="pt-0 pr-1" align="center">
                          <span class="text-313B41 w-600 font-16">ชื่อสิทธิการรักษา</span>
                        </v-col>
                        <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pr-1" align="center">
                          <span class="text-313B41 w-600 font-16">ค่าจัดส่ง Rider</span>
                        </v-col>
                        <v-col cols="3" sm="3" md="3" lg="3" class="pt-0 pr-1" align="center">
                          <span class="text-313B41 w-600 font-16">ค่าจัดส่ง Flash</span>
                        </v-col>
                        <v-col cols="1" class="pt-0" align="end">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" @click="addRights()" icon>
                                <v-icon color="#00A99D">mdi-plus-box</v-icon>
                              </v-btn>
                            </template>
                            <span>เพิ่มสิทธิการรักษา</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                      <v-row class="px-5 mt-0">
                        <v-col cols="12" style="overflow-y: auto; overflow-x: hidden; max-height: 200px;">
                          <v-row v-for="(mr, index) in hospital_detail.pharma_setup.medical_rights" :key="index" class="pb-3">
                          <v-col cols="5" class="py-0 pr-0">
                            <v-text-field
                              solo
                              dense
                              hide-details="auto"
                              placeholder="กรอกชื่อสิทธิการรักษา"
                              v-model="mr.medical_rights_name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="3" class="py-0 pr-0">
                            <v-text-field
                              solo
                              dense
                              hide-details="auto"
                              placeholder="กรอกค่าจัดส่ง Rider"
                              v-model="mr.rider"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="3" class="py-0 pr-0">
                            <v-text-field
                              solo
                              dense
                              hide-details="auto"
                              placeholder="กรอกค่าจัดส่ง Flash"
                              v-model="mr.flash"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="1" class="py-0" style="text-align: end;">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" @click="deleteRights(index)" icon>
                                  <v-icon color="#F5222D" small>mdi-minus-box</v-icon>
                                </v-btn>
                              </template>
                              <span>ลบสิทธิการรักษา</span>
                            </v-tooltip>
                          </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row class="py-3 px-5 mt-0">
                      <v-col class="pt-1 pb-0" cols="12">
                        <span class="text-313B41 w-600 font-16 pb-3">API ZONE</span>
                      </v-col>
                    </v-row>
                    <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="mx-5">
                      <v-row class="px-5 mt-0 pb-3">
                        <v-col cols="12" class="pt-0 pr-1">
                          <v-radio-group v-model="hospital_detail.pharma_setup.transport_zone" row hide-details="auto">
                            <v-row>
                              <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                                <v-radio value="UAT" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">UAT (ใช้ทดสอบ)</span>
                                  </template>
                                </v-radio>
                              </v-col>
                              <v-col cols="12" xl="6" lg="6" md="6" sm="6">
                                <v-radio value="PRD" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">PRD (ใช้จริง)</span>
                                  </template>
                                </v-radio>
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row class="py-3 px-5 mt-0">
                      <v-col class="pt-1 pb-0" cols="12">
                        <span class="text-313B41 w-600 font-16 pb-3">กำหนดระยะทางการให้บริการขนส่งยา</span>
                      </v-col>
                    </v-row>
                    <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="mx-5">
                      <v-row class="px-5 pt-0 pb-3 mt-0">
                        <v-col cols="12" class="pt-0 pr-1">
                          <v-radio-group v-model="hospital_detail.pharma_setup.area_require" row style="margin-top: 2px" hide-details="auto">
                            <v-row>
                              <v-col>
                                <v-radio :value="false" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">ไม่ต้องการกำหนดระยะทาง</span>
                                  </template>
                                </v-radio>
                              </v-col>
                              <v-col>
                                <v-radio :value="true" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">ต้องการกำหนดระยะทาง</span>
                                  </template>
                                </v-radio>
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row class="py-3 px-5 mt-0">
                      <v-col class="pt-1 pb-0" cols="12">
                        <span class="text-313B41 w-600 font-16 pb-3">กำหนดเวลาให้บริการขนส่งยา</span>
                      </v-col>
                    </v-row>
                    <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="mx-5">
                      <v-row class="px-5 pt-0 pb-3 mt-0">
                        <v-col cols="12" class="pt-0 pr-1">
                          <v-radio-group v-model="hospital_detail.pharma_setup.service_time" row style="margin-top: 2px" hide-details="auto">
                            <v-row>
                              <v-col>
                                <v-radio :value="false" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">ไม่ต้องการกำหนดเวลาให้บริการ</span>
                                  </template>
                                </v-radio>
                              </v-col>
                              <v-col>
                                <v-radio :value="true" color="#00A99D">
                                  <template v-slot:label>
                                    <span class="text-313B41 w-500 font-16">ต้องการกำหนดเวลาให้บริการ (8.30 น. - 16.30 น.)</span>
                                  </template>
                                </v-radio>
                              </v-col>
                            </v-row>
                          </v-radio-group>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row class="py-3 px-5 mt-0">
                      <v-col class="pt-1 pb-0" cols="12">
                        <span class="text-313B41 w-600 font-16 pb-3">บริการขนส่ง</span>
                      </v-col>
                    </v-row>
                    <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 10px 0px 30px;" class="mx-5">
                      <v-row class="px-5 mt-0">
                        <v-col cols="12">
                          <v-row>
                            <v-col
                              class="py-0 pl-5 mt-0"
                              cols="12"
                              sm="3"
                              md="3"
                              align-self="start"
                            >
                              <v-checkbox
                                hide-details="auto"
                                v-model="transport_service_rider"
                                color="#00A99D"
                                :value="true"
                              >
                                <template v-slot:label>
                                  <span class="text-313B41 w-600 font-16">Rider</span>
                                </template>
                              </v-checkbox>
                            </v-col>
                            <v-col cols="12" sm="8" md="8" v-if="transport_service_rider === true">
                              <v-row class="pb-0">
                                <v-col cols="12" class="pb-0">
                                  <span class="font-16 w-600 text-313B41">ประเภทการชำระเงิน</span>
                                  <v-radio-group v-model="hospital_detail.pharma_setup.pharma_payment" row style="margin-top: 2px">
                                    <v-row>
                                      <v-col>
                                        <v-radio
                                          label="QR Payment"
                                          value="QR_payment"
                                          color="#00A99D"
                                          class="mr-10 text-313B41 w-500 font-16"
                                        ></v-radio>
                                      </v-col>
                                      <v-col>
                                        <v-radio
                                          label="ชำระเงินปลายทาง"
                                          value="COD"
                                          color="#00A99D"
                                          class="mr-10 text-313B41 w-500 font-16"
                                        ></v-radio>
                                      </v-col>
                                    </v-row>
                                  </v-radio-group>
                                </v-col>
                              </v-row>
                              <v-row class="mt-0">
                                <v-col cols="12" sm="6" md="6" class="pt-0">
                                  <span class="font-16 w-600 text-313B41">ค่าจัดส่ง<span class="w-300 font-14 text-313B41"> (บาท)</span><span class="red--text">*</span></span>
                                  <v-text-field
                                    v-if="transport_service_rider == true"
                                    v-model="hospital_detail.pharma_setup.delivery_cost"
                                    placeholder="ค่าจัดส่ง"
                                    solo
                                    dense
                                    hide-details="auto"
                                    :rules="rule_flash_price"
                                    required
                                  ></v-text-field>
                                  <v-text-field
                                    v-else
                                    v-model="hospital_detail.pharma_setup.delivery_cost"
                                    placeholder="ค่าจัดส่ง"
                                    solo
                                    dense
                                    hide-details="auto"
                                    required
                                    disabled
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="1"></v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col
                              class="pt-0 pl-5 mt-0"
                              cols="12"
                              sm="3"
                              md="3"
                              align-self="start"
                            >
                              <v-checkbox
                                hide-details="auto"
                                v-model="transport_service_flash"
                                color="#00A99D"
                                :value="true"
                              >
                                <template v-slot:label>
                                  <span class="text-313B41 w-600 font-16"
                                    >Flash Express</span
                                  >
                                </template>
                              </v-checkbox>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="8"
                              md="8"
                              v-if="transport_service_flash === true"
                            >
                              <div class="boxSize">
                                <v-row style="background-color: #fff; border-radius: 8px; padding: 5px;" class="mb-0" v-for="(item, index) in hospital_detail.pharma_setup.box_size" :key="index">
                                  <v-col cols="3" class="py-1">
                                    <span class="font-18 w-700 text-313B41">ขนาด</span>
                                    <v-text-field v-model="item.title" placeholder="กรอกชื่อขนาด" solo dense hide-details="auto"
                                    :rules="rule_flash_title" required class="mt5px" @input="setValue()"></v-text-field>
                                  </v-col>
                                  <v-col cols="5" class="py-1">
                                    <span class="font-18 w-700 text-313B41">ขนาดพัสดุ</span>
                                    <v-row style="padding-top: 5px;">
                                      <v-col cols="4" class="pr-0 pb-0">
                                        <span class="font-18 w-500 text-313B41">กว้าง : </span>
                                      </v-col>
                                      <v-col cols="8" class="pl-0 pb-0">
                                        <v-text-field v-model="item.size.width" class="pb-1" placeholder="กว้าง (ซม.)" 
                                        solo dense hide-details="auto" :rules="rule_flash_width" required @input="setValue()"></v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="4" class="pr-0 py-0">
                                        <span class="font-18 w-500 text-313B41">ยาว : </span>
                                      </v-col>
                                      <v-col cols="8" class="pl-0 py-0">
                                        <v-text-field v-model="item.size.length" class="pb-1" placeholder="ยาว (ซม.)" 
                                        solo dense hide-details="auto" :rules="rule_flash_length" required @input="setValue()"></v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="4" class="pr-0 py-0">
                                        <span class="font-18 w-500 text-313B41">สูง : </span>
                                      </v-col>
                                      <v-col cols="8" class="pl-0 pt-0 ">
                                        <v-text-field v-model="item.size.height" placeholder="สูง (ซม.)" solo dense 
                                        hide-details="auto" :rules="rule_flash_height" required @input="setValue()"></v-text-field>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                  <v-col cols="3" class="py-1">
                                    <span class="font-18 w-700 text-313B41">ค่าจัดส่ง</span>
                                    <v-text-field v-model="item.size.price" placeholder="กรอกค่าจัดส่ง" solo dense hide-details="auto"
                                    :rules="rule_flash_price" required class="mt5px"  @input="setValue()"></v-text-field>
                                  </v-col>
                                  <v-col cols="1" class="pt-0 pl-2">
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" @click="deleteArea(index)" icon>
                                          <v-icon color="#F5222D" small>mdi-minus-box</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>ลบกล่อง</span>
                                    </v-tooltip>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="1"
                              md="1"
                              style="align-self: start; text-align: center;"
                              v-if="transport_service_flash === true"
                            >
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn v-bind="attrs" v-on="on" @click="addArea()" icon>
                                    <v-icon color="#00A99D"
                                      >mdi-plus-box</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span>เพิ่มกล่อง</span>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row v-if="transport_service_rider === true || transport_service_flash === true" class="py-3 px-5 mt-0">
                      <v-col class="pt-1 pb-0" cols="12">
                        <span class="text-313B41 w-600 font-16 pb-3">ข้อมูล Mobilyst</span>
                      </v-col>
                    </v-row>
                    <div v-if="transport_service_rider === true || transport_service_flash === true" style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="mx-5">
                      <v-row class="px-5 mt-0 pb-3">
                        <v-col cols="12" sm="6" md="6" class="pt-0 pr-1">
                          <span class="text-313B41 w-600 font-16 pb-3">Promotion Code</span>
                          <v-text-field
                            v-model="hospital_detail.pharma_setup.promotion_code"
                            placeholder="Promotion Code"
                            solo
                            dense
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="pt-0 pr-1">
                          <span class="text-313B41 w-600 font-16 pb-3">API Key Mobilyst</span>
                          <v-text-field
                            v-model="hospital_detail.pharma_setup.api_key_mobilyst"
                            placeholder="API Key Mobilyst"
                            solo
                            dense
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6" class="pt-0 pr-1">
                          <span class="text-313B41 w-600 font-16 pb-3">โซนพื้นที่</span>
                          <v-text-field
                            v-model="hospital_detail.pharma_setup.zone"
                            placeholder="โซนพื้นที่"
                            solo
                            dense
                            hide-details="auto"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-form>
          </v-tab-item>
          <v-tab-item v-if="items.some(e => { return e == 'Telemed' }) == true">
            <v-form ref="new_organize_telemed" class="px-3">
              <v-divider></v-divider>
              <v-card flat style="overflow-y: auto; overflow-x: hidden; min-height: 455px;" color="#ceefed">
                <v-card-text style="line-height: 1.8;">
                  <v-row class="px-5 mt-0 pb-3">
                    <v-col cols="12">
                        <v-row>
                          <!-- ค่าบริการยา -->
                          <v-col cols="12">
                            <span class="font-16 w-600 text-333333"
                              >ค่าบริการ (ต่อครั้ง)</span
                            ><span class="text-E26269 font-18 w-600">
                              *</span
                            >
                            <v-text-field
                              v-model="hospital_detail.telemed_setup.appointment_cost"
                              placeholder="ค่าบริการ/ครั้ง"
                              outlined
                              dense
                              hide-details="auto"
                              :rules="rule_appointment_cost"
                              required
                              color="#00a99d"
                            ></v-text-field>
                          </v-col>

                          <!-- ค่าบริการยา -->
                          <v-col cols="12">
                            <v-row class="pt-0 pb-3">
                              <v-col cols="12" class="pb-0 pt-0">
                                <span class="text-333333 font-16 w-600"
                                  >ค่าบริการยา</span
                                >
                                <span class="text-E26269 font-16 w-600">
                                  *</span
                                >
                              </v-col>
                              <v-col cols="12">
                                <v-row>
                                  <v-col
                                    class="pr-1 pt-0"
                                    cols="12"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                  >
                                    <v-checkbox
                                      hide-details="auto"
                                      v-model="hospital_detail.telemed_setup.free_cost_drug"
                                      color="#00A99D"
                                      value="false"
                                      class="pt-0"
                                    >
                                      <template v-slot:label>
                                        <span class="text-313B41 w-500 font-18"
                                          >ต้องชำระค่าบริการยา</span
                                        >
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col
                                    class="pr-1 pt-0"
                                    cols="12"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                  >
                                    <v-checkbox
                                      hide-details="auto"
                                      v-model="hospital_detail.telemed_setup.free_cost_drug"
                                      color="#00A99D"
                                      value="true"
                                      class="pt-0"
                                    >
                                      <template v-slot:label>
                                        <span class="text-313B41 w-500 font-18"
                                          >ฟรีค่าบริการยา</span
                                        >
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                          <!-- ช่องทางการชำระเงิน -->
                          <!-- <v-col cols="12">
                            <v-row class="pt-0 pb-3">
                              <v-col cols="12" class="pb-0 pt-0">
                                <span class="text-333333 font-16 w-600"
                                  >ช่องทางการชำระเงิน</span
                                >
                                <span class="text-E26269 font-16 w-600">
                                  *</span
                                >
                              </v-col>
                              <v-col cols="12">
                                <v-row>
                                  <v-col
                                    class="pr-1 pt-0"
                                    cols="6"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                  >
                                    <v-checkbox
                                      hide-details="auto"
                                      v-model="hospital_detail.telemed_setup.type_payment"
                                      color="#00A99D"
                                      value="true"
                                      class="pt-0"
                                    >
                                      <template v-slot:label>
                                        <span class="text-313B41 w-500 font-18"
                                          >QR Code</span
                                        >
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col
                                    class="pr-1 pt-0"
                                    cols="6"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                  >
                                    <v-checkbox
                                      hide-details="auto"
                                      v-model="hospital_detail.telemed_setup.type_payment"
                                      color="#00A99D"
                                      value="false"
                                      class="pt-0"
                                    >
                                      <template v-slot:label>
                                        <span class="text-313B41 w-500 font-18"
                                          >Thaipayment</span
                                        >
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col> -->

                          <!-- รับยาที่ร้านยาใกล้บ้าน -->
                          <!-- <v-col cols="12">
                            <v-row class="pt-0 pb-3">
                              <v-col cols="12" class="pb-0 pt-0">
                                <span class="text-333333 font-16 w-600"
                                  >รับยาที่ร้านยาใกล้บ้าน</span
                                >
                                <span class="text-E26269 font-16 w-600">
                                  *</span
                                >
                              </v-col>
                              <v-col cols="12">
                                <v-row>
                                  <v-col
                                    class="pr-1 pt-0"
                                    cols="6"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                  >
                                    <v-checkbox
                                      hide-details="auto"
                                      v-model="hospital_detail.telemed_setup.choose_pharmacy"
                                      color="#00A99D"
                                      value="true"
                                      class="pt-0"
                                    >
                                      <template v-slot:label>
                                        <span class="text-313B41 w-500 font-18"
                                          >มีบริการนี้</span
                                        >
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                  <v-col
                                    class="pr-1 pt-0"
                                    cols="6"
                                    sm="6"
                                    md="6"
                                    lg="6"
                                    xl="6"
                                  >
                                    <v-checkbox
                                      hide-details="auto"
                                      v-model="hospital_detail.telemed_setup.choose_pharmacy"
                                      color="#00A99D"
                                      value="false"
                                      class="pt-0"
                                    >
                                      <template v-slot:label>
                                        <span class="text-313B41 w-500 font-18"
                                          >ไม่มีบริการนี้</span
                                        >
                                      </template>
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col> -->
                        </v-row>         
                      </v-col>
                  </v-row>
                </v-card-text>
                <v-card-text v-if="items.some(e => { return e == 'Package' }) == true" style=" background-color: #ceefed; line-height: 1.8;min-height: 460px;overflow: auto;">
                  <div class="px-0 pb-3" fluid style="border-radius: 12px;">
                    <!-- รายการจุดตรวจ -->
                    <v-row class="py-0 px-5 mt-0">   
                      <v-col class="d-flex py-0" cols="12">
                        <span class="text-313B41 w-600 font-16">ข้อมูลจุดตรวจ</span>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" @click="openServiceCheckpoint()" icon>
                              <v-icon color="#00A99D">mdi-clipboard-edit-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>แก้ไขจุดตรวจ</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="11" class="pr-0 pt-0" v-if="checkpoint_list.length !== 0">
                        <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="ml-5 mb-5 pl-3">
                          <v-row class="px-5 mt-0 pb-3" v-for="(checkpoint, index) in checkpoint_list" :key="index">
                            <span class="text-313B41 w-600 font-14">จุดตรวจที่ {{ index + 1 }} : </span>             
                          </v-row>
                        </div>
                      </v-col>
                      <v-col cols="11" class="pr-0 pt-0" v-else>
                        <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="ml-5 mb-5 pl-3">
                          <v-row class="px-5 mt-0 pb-3" style="justify-content: center;">
                            <span class="text-313B41 w-600 font-14">กรุณาเพิ่มจุดตรวจ</span>             
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                    <!--  -->
                      
                    <v-row class="py-0 px-5 mt-0">   
                      <v-col class="d-flex py-0" cols="12">
                        <span class="text-313B41 w-600 font-16">ข้อมูล Package</span>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" @click="addPackage()" icon>
                              <v-icon color="#00A99D">mdi-plus-box</v-icon>
                            </v-btn>
                          </template>
                          <span>เพิ่ม Package</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row v-for="(mr, index) in hospital_detail.package" :key="index">
                      <v-col cols="11" class="pr-0 pt-0">
                        <div style="border: 1px solid #00A99D; border-radius: 10px; padding: 20px 0px;" class="ml-5 mb-5 pl-3">
                          <v-row class="px-5 mt-0 pb-3">
                            <v-col cols="2" sm="2" md="2" lg="2" class="pt-0 pr-1">
                              <span class="text-313B41 w-600 font-16">Package Size</span>
                            </v-col>
                            <v-col cols="2" sm="2" md="2" lg="2"  class="pt-0 pr-1">
                              <span class="text-313B41 w-600 font-16">ราคา Package (บาท)</span>
                            </v-col>
                            <v-col cols="8" sm="8" md="8" lg="8" class="pr-1">
                              <v-row>
                                <v-col cols="8" class="pt-0">
                                  <span class="text-313B41 w-600 font-16">รายการตรวจ</span>
                                </v-col>
                                <v-col cols="4" class="pt-0">
                                  <span class="text-313B41 w-600 font-16">จุดตรวจ</span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row class="px-5">
                            <v-col cols="12" class="pt-0" >
                              <v-row class="pb-3">
                                <v-col cols="2" class="py-0 pr-0">
                                  <v-text-field
                                    solo
                                    dense
                                    hide-details="auto"
                                    placeholder="กรอกชื่อ Package Size"
                                    v-model="mr.package_size"
                                    :rules="rule_package_size"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="py-0 pr-0">
                                  <v-text-field
                                    solo
                                    dense
                                    hide-details="auto"
                                    placeholder="กรอกราคา Package"
                                    v-model="mr.price"
                                    :rules="rule_price"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="8" class="pr-0 pr-1">
                                  <v-row v-for="(item, index2) in mr.order_list" :key="index2">
                                    <v-col cols="8" class="pt-0">
                                      <v-text-field
                                        solo
                                        dense
                                        hide-details="auto"
                                        placeholder="กรอกรายการตรวจ"
                                        v-model="item.name_list"
                                        :rules="rule_list"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="2" class="pt-0">
                                      <v-text-field
                                        solo
                                        dense
                                        hide-details="auto"
                                        placeholder="กรอกจุดตรวจ"
                                        type="number"
                                        v-model="item.checkpoint"
                                        :rules="rule_list"
                                      >
                                      </v-text-field>
                                    </v-col>
                                    <v-col cols="2" class="pt-0" >
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn v-bind="attrs" v-on="on" @click="deletePackageSub(index2, index)" icon>
                                            <v-icon color="#F5222D">mdi-minus-box</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>ลบรายการตรวจ</span>
                                      </v-tooltip>
                                      <v-tooltip bottom>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" v-on="on" @click="addPackageSab(mr.id)" icon>
                                          <v-icon color="#00A99D">mdi-plus-box</v-icon>
                                        </v-btn>
                                      </template>
                                      <span>เพิ่มรายการตรวจ</span>
                                    </v-tooltip>
                                    </v-col>
                                  </v-row>
                                </v-col>
                                <!-- <v-col cols="1" class="pt-0 px-0 pt-0" style="text-align: start;">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn v-bind="attrs" v-on="on" @click="addPackageSab(index)" icon>
                                        <v-icon color="#00A99D">mdi-plus-box</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>เพิ่มรายการตรวจ</span>
                                  </v-tooltip>
                                </v-col> -->
                              </v-row>
                            </v-col>
                          </v-row>
                        </div> 
                      </v-col>
                      <v-col cols="auto" align-self="center" class="pl-0 pt-0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" @click="deletePackage(index)" icon>
                              <v-icon color="#F5222D">mdi-minus-box</v-icon>
                            </v-btn>
                          </template>
                          <span>ลบ Package</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>          
                  </div>
                </v-card-text>
              </v-card>
            </v-form>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-row justify="center" align="center" class="ma-0 pb-3">
          <v-col cols="12" sm="4" md="4" class="pt-0">
            <v-btn
              depressed
              block
              color="#00A99D"
              dark
              style="border-radius: 20px 5px;"
              @click="saveHospital()"
            >
              <span class="font-16 w-500">บันทึก</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Sweetdialog ref="sweetDialog" @submit="approveSave" />
    <ServiceCheckpoint ref="serviceCheckpoint" @submit="updateServiceCheckpoint" />
    
  </v-dialog>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import box_size_default from "../box_size.json"
import Sweetdialog from '../Sweetdialog.vue'
import ServiceCheckpoint from './ServiceCheckpoint.vue'
export default {
  components: {
    Sweetdialog,
    ServiceCheckpoint,
  },
  data() {
    return {
      loading1: false,
      loading2: false,
      dialog: false,
      panel: [0, 1, 2, 3, 4, 5, 6],
      rule_name: [(v) => !!v || "กรุณากรอกชื่อองค์กรแบบเต็ม"],
      // rule_hospital: [(v) => !!v || "กรุณากรอก HospitalCode"],
      rule_business: [(v) => !!v || "กรุณากรอก BusinessID"],
      rule_organization: [(v) => !!v || "กรุณาเลือกองค์กร"],
      rule_promotion: [(v) => !!v || "กรุณากรอก Promotion Code"],
      rule_api: [(v) => !!v || "กรุณากรอก API Key Mobilyst"],
      rule_zone: [(v) => !!v || "กรุณากรอกโซนพื้นที่"],
      rule_radius_area: [(v) => !!v || "กรุณากรอกระยะทางที่กำหนด"],
      rule_flash_title: [(v) => !!v || "กรุณากรอกขนาด"],
      rule_flash_width: [(v) => !!v || "กรุณากรอกความกว้าง"],
      rule_flash_length: [(v) => !!v || "กรุณากรอกความยาว"],
      rule_flash_height: [(v) => !!v || "กรุณากรอกความสูง"],
      rule_flash_price: [(v) => !!v || "กรุณากรอกค่าจัดส่ง"],
      rule_list: [(v) => !!v || "กรุณาระบุรายการตรวจ"],
      rule_package_size: [(v) => !!v || "กรุณาระบุ Package Size"],
      rule_price: [(v) => !!v || "กรุณากรอกค่า Package", (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข"],
      rule_appointment_cost: [(v) => !!v || "กรุณากรอกค่าบริการ", (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข"],
      hospital_detail: {
        organizatio: '',
        type: '',
        biz_id: '',
        hospital_code: '',
        first_name_th: '',
        first_name_eng: '',
        organize_detail: '',
        organize_phone: '',
        organize_location: '',
        organize_logo: '',
        organize_fee: 0,
        latitude: 0,
        longitude: 0,
        taxid: '',
        organize_location_object: {
          house_no: '',
          moo: '',
          road: '',
          province: '',
          amphur: '',
          tambon: '',
          postal_code: ''
        },
        pharma_setup: {
          promotion_code: '',
          delivery_cost: 0,
          api_key_mobilyst: '',
          zone: '',
          area_require: false,
          radius_area: '',
          service_time: false,
          transport_service: '',
          pharma_payment: 'QR_payment',
          transport_zone: 'UAT',
          medical_rights: [
            {
              id: 1,
              medical_rights_name: 'บัตรทอง',
              rider: 25,
              flash: '0'
            },
            {
              id: 2,
              medical_rights_name: 'อื่น ๆ',
              rider: 75,
              flash: 'default'
            }
          ],
          box_size: box_size_default,
          service_api:false
        },
        package: [
          {
            package_size: "",
            price: "",
            order_list: [
              {
                id_list: 1,
                name_list: "",
                checkpoint:""
              }
            ]
          }
        ],
        telemed_setup: {
          free_cost_drug: "true",
          type_payment: "false",
          choose_pharmacy: "false",
          appointment_cost: "0",
        },
        account_id: '',
        service: [{ id: 1, service: 'telemed' }],
        template_conference: false,
      },
      transport_service_rider: false,
      transport_service_flash: false,
      latitude: 0,
      longitude: 0,
      lat: 0,
      lng: 0,
      set_province: [],
      set_amphoe: [],
      set_tambon: [],
      search: null,
      tab: 0,
      items: [],
      getBiz: null,
      getBizHosCode: null,
      itemTable: [],
      checkpoint_list: [],
      service: [{ id: 1, service: 'telemed' }, { id: 2, service: 'telepharma' }],
      location_address: '',
    }
  },
  computed: {
    google: gmapApi,
    checkImg() {
      if (this.hospital_detail.organize_logo === null) return true;
      if (this.hospital_detail.organize_logo === undefined) return true;
      if (this.hospital_detail.organize_logo === "") return true;

      return false;
    },
    clinic_location() {
      var text_address = "";
      if (this.hospital_detail.organize_location_object.house_no !== "" && this.hospital_detail.organize_location_object.house_no !== undefined) {
        text_address += "บ้านเลขที่ " + this.hospital_detail.organize_location_object.house_no;
      }
      if (this.hospital_detail.organize_location_object.moo !== "" && this.hospital_detail.organize_location_object.moo !== undefined) {
        text_address += " หมู่ที่ " + this.hospital_detail.organize_location_object.moo;
      }

      if (this.hospital_detail.organize_location_object.road !== "" && this.hospital_detail.organize_location_object.road !== undefined) {
        text_address += " ถนน/ซอย " + this.hospital_detail.organize_location_object.road;
      }

      if (this.hospital_detail.organize_location_object.tambon !== "" && this.hospital_detail.organize_location_object.tambon !== undefined) {
        text_address += " ตำบล/แขวง " + this.hospital_detail.organize_location_object.tambon;
      }

      if (this.hospital_detail.organize_location_object.amphur !== "" && this.hospital_detail.organize_location_object.amphur !== undefined) {
        text_address += " อำเภอ/เขต " + this.hospital_detail.organize_location_object.amphur;
      }

      if (this.hospital_detail.organize_location_object.province !== "" && this.hospital_detail.organize_location_object.province !== undefined) {
        text_address += " จังหวัด " + this.hospital_detail.organize_location_object.province;
      }

      if (this.hospital_detail.organize_location_object.postal_code !== "" && this.hospital_detail.organize_location_object.postal_code !== undefined) {
        text_address += " รหัสไปรษณีย์ " + this.hospital_detail.organize_location_object.postal_code;
      }

      return text_address;
    },
  },
  methods: {
    getGPS() {
      this.latitude = parseFloat(this.hospital_detail.latitude || 0);
      this.longitude = parseFloat(this.hospital_detail.longitude || 0);
      this.lat = parseFloat(this.hospital_detail.latitude || 0);
      this.lng = parseFloat(this.hospital_detail.longitude || 0);
    },
    async openDialog() {
      this.hospital_detail.type = 'organization'
      this.hospital_detail.service = [{ id: 1, service: 'telemed' }]
      this.showType(this.hospital_detail.type, this.hospital_detail.service)
      this.checkGPS();
      this.hospital_detail.pharma_setup.box_size = box_size_default
      await this.getProvince();
      await this.getCheckpoint()

      this.getBiz = null
      this.getBizHosCode = null
      this.dialog = true

      this.hospital_detail.package = [
        {
          id: 1,
          package_size: '',
          order_list: [
            { id_list: 1 , name_list: '', checkpoint: ""},
          ],
          price: 0
        },
      ]
    },
    showAddress() {
      var text_address = "";
      if (this.hospital_detail.organize_location_object.house_no !== "" && this.hospital_detail.organize_location_object.house_no !== undefined) {
        text_address += "บ้านเลขที่ " + this.hospital_detail.organize_location_object.house_no;
      }
      if (this.hospital_detail.organize_location_object.moo !== "" && this.hospital_detail.organize_location_object.moo !== undefined) {
        text_address += " หมู่ที่ " + this.hospital_detail.organize_location_object.moo;
      }

      if (this.hospital_detail.organize_location_object.road !== "" && this.hospital_detail.organize_location_object.road !== undefined) {
        text_address += " ถนน/ซอย " + this.hospital_detail.organize_location_object.road;
      }

      if (this.hospital_detail.organize_location_object.tambon !== "" && this.hospital_detail.organize_location_object.tambon !== undefined) {
        text_address += " ตำบล/แขวง " + this.hospital_detail.organize_location_object.tambon;
      }

      if (this.hospital_detail.organize_location_object.amphur !== "" && this.hospital_detail.organize_location_object.amphur !== undefined) {
        text_address += " อำเภอ/เขต " + this.hospital_detail.organize_location_object.amphur;
      }

      if (this.hospital_detail.organize_location_object.province !== "" && this.hospital_detail.organize_location_object.province !== undefined) {
        text_address += " จังหวัด " + this.hospital_detail.organize_location_object.province;
      }

      if (this.hospital_detail.organize_location_object.postal_code !== "" && this.hospital_detail.organize_location_object.postal_code !== undefined) {
        text_address += " รหัสไปรษณีย์ " + this.hospital_detail.organize_location_object.postal_code;
      }

      if (text_address == "") {
        this.getLocation(text_address)
        return "";
      } else {
        this.getLocation(text_address)
        return this.location_address = text_address;
      }
    },
    async getLocation(address) {
      // console.log('address', address);
      try {
        const params = new URLSearchParams();
        params.append("address", address);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/pharma/get-location?${params}`).then((res) => {
          // console.log("res", res);
          if (res.data.result == "success" && res.status == 200) {
            var data = res.data.data
            this.hospital_detail.latitude = data.lat;
            this.hospital_detail.longitude = data.lng;
            this.latitude = data.lat;
            this.longitude = data.lng;
            this.lat = data.lat;
            this.lng = data.lng;
          }
        });
      } catch (error) {
        console.error();
      }
    },
    showType(type, item) {   
      if (type == 'organization') {
        this.hospital_detail.organizatio = ''
        if (item.some(e => { return e.service == 'telemed' }) == true && item.some(e => { return e.service == 'telepharma' }) == true) {
          this.items = ['รายละเอียดองค์กร', 'Health Rider', 'Telemed']
          this.tab = 0
        } else if (item.some(e => { return e.service == 'telemed' }) == true && item.some(e => { return e.service == 'telepharma' }) == false) {
          this.items = ['รายละเอียดองค์กร', 'Telemed']
          this.tab = 0
        } else if (item.some(e => { return e.service == 'telemed' }) == false && item.some(e => { return e.service == 'telepharma' }) == true) {
          this.items = ['รายละเอียดองค์กร', 'Health Rider']
          this.tab = 0
        }
      }else if (type == 'factory'){
        this.items = ['รายละเอียดสถานประกอบการ']
        this.tab = 0
        this.getOrganizeData()
      } else {
        this.hospital_detail.organizatio = ''
        if (item.some(e => { return e.service == 'telemed' }) == true && item.some(e => { return e.service == 'telepharma' }) == true) {
          this.items = ['รายละเอียดองค์กร', 'Health Rider', 'Telemed']
          this.tab = 0
        } else if (item.some(e => { return e.service == 'telemed' }) == true && item.some(e => { return e.service == 'telepharma' }) == false) {
          this.items = ['รายละเอียดองค์กร', 'Telemed']
          this.tab = 0
        } else if (item.some(e => { return e.service == 'telemed' }) == false && item.some(e => { return e.service == 'telepharma' }) == true) {
          this.items = ['รายละเอียดองค์กร', 'Health Rider']
          this.tab = 0
        }
      }
    },
    closePage() {
      this.location_address = ''
      this.itemTable = []
      this.tab = 0
      this.hospital_detail = {
        organizatio: '',
        type: '',
        taxid: '',
        biz_id: '',
        hospital_code: '',
        first_name_th: '',
        first_name_eng: '',
        organize_detail: '',
        organize_phone: '',
        organize_location: '',
        organize_logo: '',
        organize_fee: 0,
        latitude: 0,
        longitude: 0,
        organize_location_object: {
          house_no: '',
          moo: '',
          road: '',
          province: '',
          amphur: '',
          tambon: '',
          postal_code: ''
        },
        pharma_setup: {
          promotion_code: '',
          delivery_cost: 0,
          api_key_mobilyst: '',
          zone: '',
          area_require: false,
          radius_area: '',
          service_time: false,
          transport_service: '',
          pharma_payment: true,
          transport_zone: 'UAT',
          medical_rights: [
            {
              id: 1,
              medical_rights_name: 'บัตรทอง',
              rider: 25,
              flash: '0'
            },
            {
              id: 2,
              medical_rights_name: 'อื่น ๆ',
              rider: 75,
              flash: 'default'
            }
          ],
          package: [
            {
              id: 1,
              package_size: '',
              order_list: [
                { id_list: 1 , name_list: '', checkpoint: ''},
              ],
              price: 0
            },
          ],
          box_size: [
            {
              title: '',
              size: {
                width: 0,
                length: 0,
                height: 0,
                price: 0,
              }
            }
          ],
        },
        created_at: '',
        account_id: '',
        telemed_setup: {
          free_cost_drug: "true",
          type_payment: "false",
          choose_pharmacy: "false",
          appointment_cost: "0",
        },
        service: [],
        template_conference: false,
      }
      this.getBiz = null
      this.getBizHosCode = null
      this.dialog = false
    },
    onButtonClick() {
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        {
          once: true,
        }
      );
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage(file) {
      // var image = new Image()
      var reader = new FileReader();
      // var vm = this;
      reader.onload = (e) => {
        this.hospital_detail.organize_logo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async getProvince() {
      try {
        this.hospital_detail.organize_location_object.postal_code = "";
        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/province`).then((res) => {
          // console.log('province',res);
          if (res.status == 200) {
            this.set_province = res.data.data;
          }
        });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getAmphoe(from) {
      try {
        this.hospital_detail.organize_location_object.postal_code = "";
        await this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/province/amphoe/${this.hospital_detail.organize_location_object.province}`)
          .then((res) => {
            // console.log('amphoe',res);
            if (res.status == 200) {   
                this.set_amphoe = res.data.data;

              if (from == "template") {
                this.hospital_detail.organize_location_object.amphur = "";
                this.hospital_detail.organize_location_object.tambon = "";
              }
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    async getTambon() {
      try {
        this.hospital_detail.organize_location_object.postal_code = "";
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/province/amphoe/tambon/${this.hospital_detail.organize_location_object.province}/${this.hospital_detail.organize_location_object.amphur}`
          )
          .then((res) => {
            // console.log('tambon',res);
            if (res.status == 200) {  
              this.set_tambon = res.data.data;
            }
          });
      } catch (err) {
        console.log(err);
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>เกิดข้อผิดผลาด</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      }
    },
    getPostal(e) {
      // console.log("this.set_tambon", this.set_tambon);
      var postal = this.set_tambon.find((ele) => {
        return ele.tambon === e;
      });

      if (postal !== undefined) {
        this.hospital_detail.organize_location_object.postal_code = postal.zipcode;
      } else {
        this.hospital_detail.organize_location_object.postal_code = "";
      }
    },
    setPlace(place) {
      this.search = place.formatted_address;
      this.currentPlace = place;
      this.latitude = this.currentPlace.geometry.location.lat();
      this.longitude = this.currentPlace.geometry.location.lng();
      this.lat = this.currentPlace.geometry.location.lat();
      this.lng = this.currentPlace.geometry.location.lng();
      this.hospital_detail.latitude = this.currentPlace.geometry.location.lat();
      this.hospital_detail.longitude = this.currentPlace.geometry.location.lng();
    },
    changeLocation(e) {
      // console.log("9999999", e.latLng.lat());
      // console.log("9999999", e.latLng.lng());
      this.hospital_detail.latitude = e.latLng.lat();
      this.hospital_detail.longitude = e.latLng.lng();
      this.lat = e.latLng.lat();
      this.lng = e.latLng.lng();
    },
    checkGPS() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { coords: { latitude: lat, longitude: lng } = {} } = position;
          this.latitude = lat;
          this.longitude = lng;
          this.hospital_detail.latitude = lat;
          this.hospital_detail.longitude = lng;
          this.lat = lat;
          this.lng = lng;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    deleteArea(index) {
      if (this.hospital_detail.pharma_setup.box_size.length === 1) {
        this.hospital_detail.pharma_setup.box_size = [{
          title: '',
          size: {
            width: '',
            length: '',
            height: '',
            price: ''
          }
        }]
      } else {
        this.hospital_detail.pharma_setup.box_size.splice(index, 1);
      }
    },
    addArea() {
      this.hospital_detail.pharma_setup.box_size.unshift({
        title: '',
        size: {
          width: '',
          length: '',
          height: '',
          price: ''
        }
      });
    },
    addRights() {
      this.hospital_detail.pharma_setup.medical_rights.unshift({
        'id': this.hospital_detail.pharma_setup.medical_rights.length+1,
        'medical_rights_name': '',
        'rider': '',
        'flash': ''
      });
    },
    deleteRights(index) {
      if (this.hospital_detail.pharma_setup.medical_rights.length === 1) {
        this.hospital_detail.pharma_setup.medical_rights = [
          {
            'id': '',
            'medical_rights_name': '',
            'rider': '',
            'flash': ''
          }
        ]
      } else {
        this.hospital_detail.pharma_setup.medical_rights.splice(index, 1);
      }
    },
    async addPackage() {
        await this.hospital_detail.package.unshift({
          'id': this.hospital_detail.package.length + 1,
          'package_size': '',
          'order_list': [
            { 'id_list': 1, 'name_list': '', 'checkpoint': "" },
          ],
          'price': 0
        });
    },
    addPackageSab(item) {
        var data = this.hospital_detail.package.find(ele => {
          return ele.id == item
        })
        data.order_list.unshift({
          id_list: data.order_list.length + 1,
          name_list: '',
          checkpoint: '',
        })
    },
    deletePackageSub(index2, index) {
      if (this.hospital_detail.package.length === 1) {
        if (this.hospital_detail.package[index].order_list.length == 1) {
          this.hospital_detail.package = [
            {
              'id': '',
              'package_size': '',
              'order_list': [
                { 'id_list': 1, 'name_list': '', 'checkpoint': "" },
              ],
              'price': 0
            }
          ]
        } else {
          this.hospital_detail.package[index].order_list.splice(index2, 1);
        }
        
      } else {
        if (this.hospital_detail.package[index].order_list.length == 1) {
          this.$swal({
            title:
              "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;font-weight: 500;'>ท่านต้องการลบข้อมูลแพ็คเกจนี้ใช่หรือไม่</span>",
            icon: "warning",
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonText:
              "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
            cancelButtonColor: "#FFFFFF",
            showConfirmButton: true,
            confirmButtonText:
              "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
            confirmButtonColor: "#00A99D",
            allowOutsideClick: false,
          }).then(async (result) => {
            if (result.isConfirmed) {
              this.hospital_detail.package.splice(index, 1);
            }
          })
        } else {
          this.hospital_detail.package[index].order_list.splice(index2, 1);
        }
      }
    },
    deletePackage(index) {
      this.$swal({
        title:
          "<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;font-weight: 500;'>ท่านต้องการลบข้อมูลแพ็คเกจนี้ใช่หรือไม่</span>",
        icon: "warning",
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText:
          "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
        cancelButtonColor: "#FFFFFF",
        showConfirmButton: true,
        confirmButtonText:
          "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
        confirmButtonColor: "#00A99D",
        allowOutsideClick: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (this.hospital_detail.package.length === 1) {
            this.hospital_detail.package = [
              {
                'id': '',
                'package_size': '',
                'order_list': [
                  { 'id_list': 1, 'name_list': '' ,'checkpoint': ""},
                ],
                'price': 0
              }
            ]
          } else {
            this.hospital_detail.package.splice(index, 1);
          }
        }
      })
    },
    saveHospital() {  
      if (
        ("new_organize" in this.$refs && !this.$refs.new_organize.validate()) || 
        ("new_organize_pharma" in this.$refs && (this.hospital_detail.service.some(e => e.service == 'telepharma') == true && !this.$refs.new_organize_pharma.validate())) ||
        ("new_organize_telemed" in this.$refs && (this.hospital_detail.service.some(e => e.service == 'telemed') == true && !this.$refs.new_organize_telemed.validate()))
      ) {
        this.$swal({
          title:
            "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>กรุณากรอกข้อมูลให้ครบถ้วน</span>",
          icon: "error",
          showCloseButton: false,
          showConfirmButton: false,
          background: "white",
          timer: 3000,
        });
      } else {
        const data = {
          title: "<span style='color: black;font-size: 24px;font-family: Sarabun;font-weight: 500;'><b>ท่านยืนยันเพิ่มข้อมูลนี้ใช่หรือไม่ ?</b></span>",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          cancelButtonText: "<span style='color: #F5222D;font-size: 16px;font-family: Sarabun, sans-serif'>ยกเลิก</span>",
          cancelButtonColor: "#FFFFFF",
          showConfirmButton: true,
          confirmButtonText: "<span style='font-size: 16px;font-family: Sarabun, sans-serif;'>ยืนยัน</span>",
          confirmButtonColor: "#00A99D",
          allowOutsideClick: false,
          returnEmit: 'confirm',
        }
        this.$refs.sweetDialog.open(data)
      } 
    },
    approveSave() {
      var body = {}

      this.hospital_detail.organize_location = this.clinic_location
      this.hospital_detail.account_id = sessionStorage.getItem("account_id")
    
      if (this.hospital_detail.type !== 'factory') {
        // pharma_setup
        if(this.transport_service_rider == true && (this.transport_service_flash == '' || this.transport_service_flash == false)) {
          this.hospital_detail.pharma_setup.transport_service = 'rider'
        } else if((this.transport_service_rider == '' && this.transport_service_rider == false) && this.transport_service_flash == true) {
          this.hospital_detail.pharma_setup.transport_service = 'flash'
        } else if(this.transport_service_rider == true && this.transport_service_flash == true) {
          this.hospital_detail.pharma_setup.transport_service = 'multiTransport'
        } else {
          this.hospital_detail.pharma_setup.transport_service = ''
        }
        // mad_setup
        // this.hospital_detail.mad_setup.free_cost_drug = this.telemed_setup.free_cost_drug
        // this.hospital_detail.mad_setup.type_payment = this.telemed_setup.type_payment
        // this.hospital_detail.mad_setup.choose_pharmacy = this.telemed_setup.choose_pharmacy
        // this.hospital_detail.mad_setup.appointment_cost = this.telemed_setup.appointment_cost
        body = this.hospital_detail
        
      } else {
        body = {
          type: this.hospital_detail.type,
          organizatio: this.hospital_detail.organizatio,
          biz_id: this.hospital_detail.biz_id,
          first_name_th: this.hospital_detail.first_name_th,
          first_name_eng: this.hospital_detail.first_name_eng,
          organize_detail: this.hospital_detail.organize_detail,
          organize_phone: this.hospital_detail.organize_phone,
          organize_logo: this.hospital_detail.organize_logo,
          organize_location: this.clinic_location,
          organize_location_object: this.hospital_detail.organize_location_object,
          latitude: this.hospital_detail.latitude,
          longitude: this.hospital_detail.longitude,
          taxid: this.hospital_detail.taxid,
          account_id: sessionStorage.getItem("account_id")
        }
      }

      try {
        this.axios.post(process.env.VUE_APP_BACKEND_URL+`/v1/organization/create_organization`, body)
        .then((res) => {
          if(res.data.result == 'success') {
            this.$swal({
              title:"<span style='color: black;font-size: 20px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลสำเร็จ</span>",
              icon: "success",
              showConfirmButton: false,
              confirmButtonText: "ปิด",
              confirmButtonColor: "#00A99D",
            }).then(() => {
              this.checkPlatform()
              this.addPackageSize()
            })
          } else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>บันทึกข้อมูลไม่สำเร็จ</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
            this.$emit("close");
            this.closePage();
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async getHospitalBiz(biz_id) {
      try {
        this.loading1 = true
        setTimeout(() => {
          this.loading1 = false
        }, 3000)
        this.hospital_detail.hospital_code = ""
        this.hospital_detail.first_name_th = ""
        this.hospital_detail.first_name_eng = ""
        // console.log(biz_id);
        const params = new URLSearchParams();
        params.append("business_id", biz_id);

        await this.axios.get(process.env.VUE_APP_BACKEND_URL+`/v1/hospital/biz?${params}`).then((res) => {
          // console.log(res);
          if (res.data.result == "success" && res.data.code == 200) {
            this.getBiz = true

            var data = res.data.data

            this.hospital_detail.hospital_code = data.hospital_code
            this.hospital_detail.first_name_th = data.name_th
            this.hospital_detail.first_name_eng = data.name_eng
          } else {
            this.getBiz = false
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async getHospitalHosCode(hospital_code) {
      try {
        this.loading2 = true
        setTimeout(() => [
          this.loading2 = false
        ], 3000)
        this.hospital_detail.biz_id = ""
        this.hospital_detail.first_name_th = ""
        this.hospital_detail.first_name_eng = ""
        // console.log(hospital_code);
        const params = new URLSearchParams();
        params.append("hospital_code", hospital_code);

        await this.axios.get(process.env.VUE_APP_BACKEND_URL+`/v1/hospital/hospital_code?${params}`).then((res) => {
          // console.log(res);
          if (res.data.result == "success" && res.data.code == 200) {
            this.getBizHosCode = true

            var data = res.data.data

            this.hospital_detail.biz_id = data.business_id
            this.hospital_detail.first_name_th = data.name_th
            this.hospital_detail.first_name_eng = data.name_eng

          } else {
            this.getBizHosCode = false
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async checkPlatform() {
      try {
        var data = {
          biz_id: this.hospital_detail.biz_id,
          first_name_th: this.hospital_detail.first_name_th,
          first_name_eng: this.hospital_detail.first_name_eng,
          hospital_code: this.hospital_detail.hospital_code,
        }

        await this.axios.post(process.env.VUE_APP_BACKEND_URL + `/v1/check/platform`,data).then((res) => {
          // console.log(res);
          if (res.data.result == "success" && res.data.code == 200) {
            this.$emit("close");
            this.closePage();
          } else {
            this.$emit("close");
            this.closePage();
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async addPackageSize() {
      try {
        var data = {
          biz_id: this.hospital_detail.biz_id,
          package: this.hospital_detail.package
        }

        await this.axios.post(process.env.VUE_APP_BACKEND_URL + `/v1/add/package`, data,
        ).then((res) => {
          if (res.data.code == 200 && res.data.result == "success") {
            console.log(res);
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    getOrganizeData() {
      try {
        var params = new URLSearchParams();
        params.append('limit', '')
        params.append('page', '')
        params.append('type', 'organization')

        this.axios.post(process.env.VUE_APP_BACKEND_URL+`/v1/organization/getOrganizationOnly?${params}`)
        .then((res) => {
          if(res.data.result == 'success') {
            this.itemTable = res.data.data.data
          }
        })
      } catch(err) {
        console.log(err);
      } 
    },
    async getCheckpoint(biz_id) {
      try {
        // console.log(biz_id);
        const params = new URLSearchParams();
        params.append("business_id", biz_id);

        await this.axios.get(process.env.VUE_APP_BACKEND_URL+`/v1/get/checkpoint?${params}`).then((res) => {
          console.log("/v1/get/checkpoint:", res);
          if (res.data.result == "success" && res.data.code == 200) {
            this.getBiz = true

            var data = res.data.data

            this.checkpoint_list = data
          } else {
            this.getBiz = false
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    openServiceCheckpoint() {
      this.$refs.serviceCheckpoint.openDialog("RegisterHospital", this.hospital_detail.biz_id)
    },
    async updateServiceCheckpoint() {
      console.log("updateServiceCheckpoint");
    }
  }
}
</script>

<style scoped>
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: 0px 0px 0px 0px !important;
}
::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
  background-color: #ffffff;
}
.gmap-auto:focus {
  outline: none !important;
}
.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}
::v-deep .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
  color: #333333;
  font-size: 18px;
  font-weight: 700;
}
::v-deep .v-tab.v-tab {
  font-size: 18px;
  font-weight: 700;
}
.v-divider {
  display: block;
  flex: 1 1 0px;
  max-width: 100%;
  height: 0px;
  max-height: 0px;
  border: solid;
  border-width: thin;
  transition: inherit;
  color: #00A99D;
}
.boxSize {
   overflow-y: auto;
   overflow-x: hidden;
   height: auto;
   max-height: 540px;
   padding: 15px 15px 5px 15px;
}
::v-deep .v-textarea.v-text-field--solo .v-input__control textarea {
  color: #333333;
}

::v-deep .v-input__append-outer{
  margin-top: 0px !important;
}
</style>